<list-page
    [header]="!!(items$ | async)?.length"
    [items]="items$ | async"
    [page]="page$ | async"
    [perPage]="perPage$ | async"
    [totalCount]="totalCount$ | async"
    [displaySort]="false"
    [rowAnchor]="rowAnchor"
    [skeleton]="skeleton"
    [emptyState]="emptyState"
    (reload)="onReload($event)"
>
</list-page>
